export default __webpack_public_path__ + "static/media/Fustat-Medium.71035ca4.ttf";